import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  IonList,
  IonItem,
  IonLabel,
  IonText,
  IonIcon,
  IonListHeader,
} from '@ionic/react';
import { add } from 'ionicons/icons';
import { PaySelectors } from 'redux/PayRedux';
import { MethodItem } from 'components/methods';

function CurrentPaymentItem() {
  const history = useHistory();
  const currentItem = useSelector(PaySelectors.selectActivePaymentMethod);

  return (
    <IonList>
      <IonListHeader>
        <IonLabel>Payment Type</IonLabel>
      </IonListHeader>
      {currentItem ? (
        <MethodItem
          item={currentItem}
          onClick={() => history.push('/payment-methods')}
        />
      ) : (
        <IonItem button onClick={() => history.push('/payment-methods/add')}>
          <IonIcon slot="start" icon={add} />
          <IonLabel>
            <IonText color="primary">Add Card</IonText>
          </IonLabel>
        </IonItem>
      )}
    </IonList>
  );
}

CurrentPaymentItem.propTypes = {};

export default CurrentPaymentItem;
